import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/salesData';
import { BonusMockup } from './BonusMockup';
const coverColors = ['#8FBCD8', '#C99A4B', '#D2694A', '#5C92B8', '#A6603F', '#3E6E90' // deep celeste
];
export function BonusSection() {
  return <section className="py-20 px-4 bg-surface-light" data-id="element-26">
      <div className="max-w-6xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-28">
          <h2 className="text-4xl md:text-6xl font-black mb-6 text-primary tracking-tight" data-id="element-29">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-30">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center gap-2 bg-accent text-white px-8 py-4 rounded-full font-bold text-xl shadow-lg" data-id="element-31">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-32">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.1
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-33">
              <BonusMockup number={bonus.id} icon={bonus.icon} coverColor={coverColors[index % coverColors.length]} data-id="element-34" />

              <div className="mt-6 mb-4" data-id="element-35">
                <span className="inline-block bg-surface-accent text-primary px-5 py-1.5 rounded-full text-sm font-bold tracking-wide" data-id="element-36">
                  GRATIS
                </span>
              </div>

              <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-3 leading-tight" data-id="element-37">
                {bonus.icon} Bonus {bonus.id} — {bonus.title}
              </h3>

              <p className="text-gray-500 text-base leading-relaxed" data-id="element-38">
                {bonus.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}